<template>
  <div class="recruitingAdd">
    <el-page-header @back="$router.go(-1)" content="添加职位" style="padding-top: 20px;">
    </el-page-header>
    <div class="classify_box">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
        <el-form-item label="角色名称:" prop="name">
          <el-input v-model="ruleForm.name"></el-input>
        </el-form-item>


        <el-form-item label="角色描述:" prop="remark">
          <el-input type="textarea" :rows="5" placeholder="请输入内容" v-model="ruleForm.remark">
          </el-input>
        </el-form-item>

        <el-form-item label="排序:" prop="ordid">
          <el-input type="number" v-model="ruleForm.ordid"></el-input>
        </el-form-item>

        <el-form-item label="部门:">
          <el-select v-model="ruleForm.deparment_id" placeholder="请选择工作职位" @change="departmentChange">
            <el-option :label="item.name" :value="item.id" v-for='(item,index) in departmentList' :key='index'></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="是否激活:">
          <el-switch v-model="display" @change="handleSwitch"></el-switch>
        </el-form-item>

<!--
        <el-form-item label="任务状态:" prop="hastask">
          <el-select clearable v-model="ruleForm.hastask" placeholder="选择任务状态">
            <el-option label="没有任务" value="1"></el-option>
            <el-option label="有任务" value="2"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="每天采集数量:" v-if='ruleForm.hastask == 2' prop='daycollect'>
          <el-input type="number" v-model="ruleForm.daycollect"></el-input>
        </el-form-item>

        <el-form-item label="每天面试数量:"  v-if='ruleForm.hastask == 2' prop='dayinterview'>
          <el-input type="number" v-model="ruleForm.dayinterview"></el-input>
        </el-form-item>

        <el-form-item label="每天入职数量:"  v-if='ruleForm.hastask == 2' prop='dayentry'>
          <el-input type="number" v-model="ruleForm.dayentry"></el-input>
        </el-form-item>

        <el-form-item label="每月在职人数:"  v-if='ruleForm.hastask == 2' prop='monthentry'>
          <el-input type="number" v-model="ruleForm.monthentry"></el-input>
        </el-form-item>

        <el-form-item label="第一月指标:"  v-if='ruleForm.hastask == 2' prop='target1'>
          <el-input type="number" v-model="ruleForm.target1"></el-input>
        </el-form-item>

        <el-form-item label="第二月指标:"  v-if='ruleForm.hastask == 2' prop='target2'>
          <el-input type="number" v-model="ruleForm.target2"></el-input>
        </el-form-item>

        <el-form-item label="第三月指标:"  v-if='ruleForm.hastask == 2' prop='target3'>
          <el-input type="number" v-model="ruleForm.target3"></el-input>
        </el-form-item>

        <el-form-item label="第四月指标:"  v-if='ruleForm.hastask == 2' prop='target4'>
          <el-input type="number" v-model="ruleForm.target4"></el-input>
        </el-form-item> -->

        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
          <el-button @click="handleGo">返回</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
  import {
    Message
  } from "element-ui";
  export default {
    data() {
      return {
        ruleForm: {
          deparment_id:'',
          status: 0,
          // hastask:'',
          // daycollect:'',
          // dayinterview:'',
          // dayentry:'',
          // monthentry:'',
          // target1:'',
          // target2:'',
          // target3:'',
          // target4:'',
        },
        rules: {
          name: [{
            required: true,
            message: "请输入角色名称",
            trigger: "blur"
          }],
          remark: [{
            required: true,
            message: "请输入角色描述",
            trigger: "blur"
          }],
          ordid: [{
            required: true,
            message: "请输入排序",
            trigger: "blur"
          }],
          status: [{
            required: true,
            message: "请选择是否激活",
            trigger: "change"
          }],
          deparment_id:[
            {
              required: true,
              message: "请选择部门",
              trigger: "change"
            }
          ],
          // hastask:[{
          //   required: true,
          //   message: "请选择任务状态",
          //   trigger: "change"
          // }],
          daycollect:[{
            required: true,
            message: "请输入每天采集数量",
            trigger: "blur"
          }],
          dayinterview:[{
            required: true,
            message: "请输入每天面试数量",
            trigger: "blur"
          }],
          dayentry:[{
            required: true,
            message: "请输入每天入职数量",
            trigger: "blur"
          }],
          monthentry:[{
            required: true,
            message: "每月在职人数",
            trigger: "blur"
          }],
          target1:[{
            required: true,
            message: "请输入第一月指标",
            trigger: "blur"
          }],
          target2:[{
            required: true,
            message: "请输入第二月指标",
            trigger: "blur"
          }],
          target3:[{
            required: true,
            message: "请输入第三月指标",
            trigger: "blur"
          }],
          target4:[{
            required: true,
            message: "请输入第四月指标",
            trigger: "blur"
          }]
        },
        id: "",
        display: false,
        departmentList: [],
        deparment_id:''

      };
    },
    activated() {
      this.id = this.$route.query.id;
      this.getDepartment()
      if (this.id) {
        this.getInfo();
      }

    },
    methods: {

      departmentChange(e){
        this.ruleForm.deparment_id = e
      },

      handleSwitch(e) {
        if (e) {
          this.ruleForm.status = 1;
        } else {
          this.ruleForm.status = 0;
        }
      },

      getInfo() {
        this.gets("adminrole/edit?id=" + this.id).then((res) => {
          this.ruleForm = res.data.data;
          this.ruleForm.hastask = res.data.data.hastask + ''
          this.ruleForm.deparment_id = res.data.data.deparment_id + ''
          this.deparment_id = res.data.data.deparment_id + ''
          if (res.data.data.status == 1) {
            this.display = true
          } else {
            this.display = false
          }
        });
      },

      getDepartment() {
        this.gets('oasystem/departmentlist').then(res => {
          this.departmentList = res.data.data
          this.departmentList = this.departmentList.map((item)=>{
            item.id = item.id + ''
            return item
          })
        })
      },

      handleGo() {
        this.$router.go(-1);
      },

      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if (this.id) {
              this.post("adminrole/edit", this.ruleForm).then((res) => {
                if (res.data.code == 1) {
                  Message.success(res.data.msg);
                  var that = this;
                  setTimeout(function() {
                    that.$router.go(-1);
                  }, 1000);
                } else {
                  Message.error(res.data.msg);
                }
              });
            } else {
              this.post("adminrole/add", this.ruleForm).then((res) => {
                if (res.data.code == 1) {
                  Message.success(res.data.msg);
                  var that = this;
                  setTimeout(function() {
                    that.$router.go(-1);
                  }, 1000);
                } else {
                  Message.error(res.data.msg);
                }
              });
            }
          } else {
            return console.log("error submit!!");
          }
        });
      },
    },
  };
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/system/roleAdd.vue